export default __webpack_public_path__ + "static/media/bi_arrow-left.6bbebc75.svg";